"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const page_section_1 = __importDefault(require("~components/page-section"));
const shared_1 = require("~styles/shared");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const heading_1 = require("~components/heading");
const paragraph_1 = require("~components/paragraph");
const iconHeight = 54;
const iconMap = {
    ingestion: {
        name: 'email-ingestion',
        width: 62,
    },
    parsing: {
        name: 'parsing',
        width: 62,
    },
    reporting: {
        name: 'reporting',
        width: 51,
    },
};
const CardComponent = ({ card }) => {
    const icon = iconMap[card.type];
    return ((0, jsx_runtime_1.jsxs)(styled_1.StyledCard, { children: [(0, jsx_runtime_1.jsx)(ui_1.Flex, { justify: "center", spacer: "x3", children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: icon.name, size: { width: icon.width, height: iconHeight }, color: "silverPearl" }) }), (0, jsx_runtime_1.jsx)(heading_1.Heading, { level: 3, as: 4, spacer: "x3", children: card.title }), card.description.split('\n').map((paragraph, index) => ((0, jsx_runtime_1.jsx)(paragraph_1.Paragraph, { size: "large", children: paragraph }, index)))] }));
};
const ThreeCardSection = ({ id, title, intro, cards }) => ((0, jsx_runtime_1.jsx)(page_section_1.default, { id: id, title: title, intro: intro, headerSpacer: ['x6', null, 'x9'], contentGrid: shared_1.smallContentGrid, children: (0, jsx_runtime_1.jsx)(ui_1.Flex, { direction: ['column', null, 'row'], gap: "x3", justify: "space-between", children: cards.map((card) => ((0, jsx_runtime_1.jsx)(CardComponent, { card: card }, card.id))) }) }));
exports.default = ThreeCardSection;
